module.exports = __webpack_public_path__ + "img/img17.98956d42.png";